export const RQ_GET_MENUS_USER_ID_API = {
  url: 'v2/menu/for-user/<%= id %>?',
  method: 'GET',
  auth: true,
  search: true,
};
